import gql from 'graphql-tag';

export default gql`
    mutation RunOrder($input: RunOrderInput) {
        runOrder(input: $input) {
            errors
        }
    }
`;
